// extracted by mini-css-extract-plugin
export var image = "ContactGrid-module--image--1zSmk";